import { PersistedIPAllowlistEntry } from '@ardoq/api-types';
import { crudApi } from './api';

export const allowlistApi = crudApi<PersistedIPAllowlistEntry>(
  'organization/whitelist/configure'
);
